import AccountingInfoOption from './AccountingInfoOption';

export default class GeneralBusinessPostingGroup extends AccountingInfoOption {
    public static entity = 'generalBusinessPostingGroups';
    public static apiType = 'general-business-posting-groups';
    public static storageKey = 'general_business_posting_groups_list';
}